import { Stack, Text } from "@mantine/core"
import { CertificateRequestStatus } from "@tfg/db/browser"
import { Loader } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useFindCertificateRequestsByCertificateId } from "~/gen/api/hooks/useFindCertificateRequestsByCertificateId"
import { CertificateByOrganizationDto } from "~/gen/api/types/CertificateByOrganizationDto"
import { CompletedCertificateRequests } from "~/pages/Brand/Certificates/components/CompletedCertificateRequests"
import { SubmittedCertificateRequests } from "~/pages/Brand/Certificates/components/SubmittedCertificateRequests"

type CertificateRequestsValidationListProps = {
  certificate: CertificateByOrganizationDto
}

export const CertificateRequestsValidationList = ({
  certificate,
}: CertificateRequestsValidationListProps) => {
  const { t } = useTranslation("certificates")

  const statuses = [
    CertificateRequestStatus.SUBMITTED,
    CertificateRequestStatus.ACCEPTED,
    CertificateRequestStatus.REJECTED,
  ] as const

  const [openedStatus, setOpenedStatus] =
    useState<CertificateRequestStatus | null>(
      CertificateRequestStatus.SUBMITTED
    )

  const { data: certificateRequestsResponse, isLoading } =
    useFindCertificateRequestsByCertificateId({
      certificateId: certificate.id,
      status: [...statuses],
    })

  const certificateRequests = certificateRequestsResponse?.data

  if (!certificateRequests || isLoading) {
    return <Loader />
  }

  const completedCertificateRequests = [
    certificateRequests.accepted,
    certificateRequests.rejected,
  ]

  return (
    <Stack gap="sm" mt="md">
      <Text>
        {t("modal.associatedRequests.description", {
          sender: certificate.createdBy.organization.name,
        })}
      </Text>
      {completedCertificateRequests.map((data) => (
        <CompletedCertificateRequests
          key={data.status}
          data={data}
          openedStatus={openedStatus}
          setOpenedStatus={setOpenedStatus}
        />
      ))}
      <SubmittedCertificateRequests
        data={certificateRequests.submitted}
        certificate={certificate}
        openedStatus={openedStatus}
        setOpenedStatus={setOpenedStatus}
      />
    </Stack>
  )
}
